export function NotFound(root) {
  root.innerHTML = `
    <div class="card text-center py-16 max-w-md mx-auto">
      <div class="text-5xl mb-4">🧭</div>
      <h1 class="font-display text-2xl font-semibold text-slate2-900">Hva?</h1>
      <p class="mt-2 text-slate2-500">
        That page doesn't exist — at least not yet.
      </p>
      <a href="/dashboard" data-link class="btn-primary mt-6">← Dashboard</a>
    </div>
  `;
}
